module.exports = __webpack_public_path__ + "img/1d4ea78.png";